<div class="weaveSearch">
  <i class="material-icons searchIcon">search</i>
  <input class="searchField"
         [placeholder]="placeholder"
         [(ngModel)]="searchQuery"
         (input)="filterItems()"
         name="searchQuery"
         [attr.aria-label]="label"
  >
</div>
